type CountryRecord = Record<string, { country: string; nationality: string }>;

export const countryMap: CountryRecord = {
  FR: { country: "France", nationality: "Française" },
  MA: { country: "Maroc", nationality: "Marocaine" },
  TN: { country: "Tunisie", nationality: "Tunisienne" },
  DZ: { country: "Algérie", nationality: "Algérienne" },
  AD: { country: "Andorre", nationality: "Andorrane" },
  AE: { country: "Émirats arabes unis", nationality: "Émirienne" },
  AF: { country: "Afghanistan", nationality: "Afghane" },
  AG: { country: "Antigua-et-Barbuda", nationality: "Antiguaise" },
  AL: { country: "Albanie", nationality: "Albanaise" },
  AM: { country: "Arménie", nationality: "Arménienne" },
  AO: { country: "Angola", nationality: "Angolaise" },
  AR: { country: "Argentine", nationality: "Argentine" },
  AT: { country: "Autriche", nationality: "Autrichienne" },
  AU: { country: "Australie", nationality: "Australienne" },
  AZ: { country: "Azerbaïdjan", nationality: "Azerbaïdjanaise" },
  BA: { country: "Bosnie-Herzégovine", nationality: "Bosnienne" },
  BB: { country: "Barbade", nationality: "Barbadienne" },
  BD: { country: "Bangladesh", nationality: "Bangladaise" },
  BE: { country: "Belgique", nationality: "Belge" },
  BF: { country: "Burkina Faso", nationality: "Burkinabée" },
  BG: { country: "Bulgarie", nationality: "Bulgare" },
  BH: { country: "Bahreïn", nationality: "Bahreïnienne" },
  BI: { country: "Burundi", nationality: "Burundaise" },
  BJ: { country: "Bénin", nationality: "Béninoise" },
  BN: { country: "Brunéi Darussalam", nationality: "Brunéienne" },
  BO: { country: "Bolivie", nationality: "Bolivienne" },
  BR: { country: "Brésil", nationality: "Brésilienne" },
  BS: { country: "Bahamas", nationality: "Bahaméenne" },
  BT: { country: "Bhoutan", nationality: "Bhoutanaise" },
  BW: { country: "Botswana", nationality: "Botswanaise" },
  BY: { country: "Biélorussie", nationality: "Biélorusse" },
  BZ: { country: "Belize", nationality: "Bélizienne" },
  CA: { country: "Canada", nationality: "Canadienne" },
  CD: { country: "République démocratique du Congo", nationality: "Congolaise" },
  CF: { country: "République centrafricaine", nationality: "Centrafricaine" },
  CG: { country: "Congo", nationality: "Congolaise" },
  CH: { country: "Suisse", nationality: "Suisse" },
  CI: { country: "Côte d'Ivoire", nationality: "Ivoirienne" },
  CL: { country: "Chili", nationality: "Chilienne" },
  CM: { country: "Cameroun", nationality: "Camerounaise" },
  CN: { country: "Chine", nationality: "Chinoise" },
  CO: { country: "Colombie", nationality: "Colombienne" },
  CR: { country: "Costa Rica", nationality: "Costaricaine" },
  CU: { country: "Cuba", nationality: "Cubaine" },
  CV: { country: "Cap-Vert", nationality: "Cap-verdienne" },
  CY: { country: "Chypre", nationality: "Chypriote" },
  CZ: { country: "République tchèque", nationality: "Tchèque" },
  DE: { country: "Allemagne", nationality: "Allemande" },
  DJ: { country: "Djibouti", nationality: "Djiboutienne" },
  DK: { country: "Danemark", nationality: "Danoise" },
  DM: { country: "Dominique", nationality: "Dominiquaise" },
  DO: { country: "République dominicaine", nationality: "Dominicaine" },
  EC: { country: "Équateur", nationality: "Équatorienne" },
  EE: { country: "Estonie", nationality: "Estonienne" },
  EG: { country: "Égypte", nationality: "Égyptienne" },
  EH: { country: "Sahara occidental", nationality: "Sahraouie" },
  ER: { country: "Érythrée", nationality: "Érythréenne" },
  ES: { country: "Espagne", nationality: "Espagnole" },
  ET: { country: "Éthiopie", nationality: "Éthiopienne" },
  FI: { country: "Finlande", nationality: "Finlandaise" },
  FJ: { country: "Fidji", nationality: "Fidjienne" },
  FM: { country: "Micronésie", nationality: "Micronésienne" },
  GA: { country: "Gabon", nationality: "Gabonaise" },
  GB: { country: "Royaume-Uni", nationality: "Britannique" },
  GD: { country: "Grenade", nationality: "Grenadienne" },
  GE: { country: "Géorgie", nationality: "Géorgienne" },
  GH: { country: "Ghana", nationality: "Ghanéenne" },
  GM: { country: "Gambie", nationality: "Gambienne" },
  GN: { country: "Guinée", nationality: "Guinéenne" },
  GQ: { country: "Guinée équatoriale", nationality: "Équato-guinéenne" },
  GR: { country: "Grèce", nationality: "Grecque" },
  GT: { country: "Guatemala", nationality: "Guatémaltèque" },
  GW: { country: "Guinée-Bissau", nationality: "Bissau-Guinéenne" },
  GY: { country: "Guyana", nationality: "Guyanienne" },
  HN: { country: "Honduras", nationality: "Hondurienne" },
  HR: { country: "Croatie", nationality: "Croate" },
  HT: { country: "Haïti", nationality: "Haïtienne" },
  HU: { country: "Hongrie", nationality: "Hongroise" },
  ID: { country: "Indonésie", nationality: "Indonésienne" },
  IE: { country: "Irlande", nationality: "Irlandaise" },
  IL: { country: "Israël", nationality: "Israélienne" },
  IN: { country: "Inde", nationality: "Indienne" },
  IQ: { country: "Irak", nationality: "Irakienne" },
  IR: { country: "Iran", nationality: "Iranienne" },
  IS: { country: "Islande", nationality: "Islandaise" },
  IT: { country: "Italie", nationality: "Italienne" },
  JM: { country: "Jamaïque", nationality: "Jamaïcaine" },
  JO: { country: "Jordanie", nationality: "Jordanienne" },
  JP: { country: "Japon", nationality: "Japonaise" },
  KE: { country: "Kenya", nationality: "Kényane" },
  KG: { country: "Kirghizistan", nationality: "Kirghize" },
  KH: { country: "Cambodge", nationality: "Cambodgienne" },
  KI: { country: "Kiribati", nationality: "Kiribatienne" },
  KM: { country: "Comores", nationality: "Comorienne" },
  KN: { country: "Saint-Kitts-et-Nevis", nationality: "Saint-Kittsienne" },
  KP: { country: "Corée du Nord", nationality: "Coréenne du Nord" },
  KR: { country: "Corée du Sud", nationality: "Coréenne du Sud" },
  KW: { country: "Koweït", nationality: "Koweïtienne" },
  KZ: { country: "Kazakhstan", nationality: "Kazakhe" },
  LA: { country: "Laos", nationality: "Laotienne" },
  LB: { country: "Liban", nationality: "Libanaise" },
  LC: { country: "Sainte-Lucie", nationality: "Saint-Lucienne" },
  LI: { country: "Liechtenstein", nationality: "Liechtensteinoise" },
  LK: { country: "Sri Lanka", nationality: "Sri-Lankaise" },
  LR: { country: "Libéria", nationality: "Libérienne" },
  LS: { country: "Lesotho", nationality: "Lesothane" },
  LT: { country: "Lituanie", nationality: "Lituanienne" },
  LU: { country: "Luxembourg", nationality: "Luxembourgeoise" },
  LV: { country: "Lettonie", nationality: "Lettonne" },
  LY: { country: "Libye", nationality: "Libyenne" },
  MC: { country: "Monaco", nationality: "Monégasque" },
  MD: { country: "Moldavie", nationality: "Moldave" },
  ME: { country: "Monténégro", nationality: "Monténégrine" },
  MG: { country: "Madagascar", nationality: "Malgache" },
  MH: { country: "Îles Marshall", nationality: "Marshallaise" },
  MK: { country: "Macédoine du Nord", nationality: "Macédonienne" },
  ML: { country: "Mali", nationality: "Malienne" },
  MM: { country: "Myanmar", nationality: "Myanmaraise" },
  MN: { country: "Mongolie", nationality: "Mongole" },
  MR: { country: "Mauritanie", nationality: "Mauritanienne" },
  MT: { country: "Malte", nationality: "Maltaise" },
  MU: { country: "Maurice", nationality: "Mauricienne" },
  MV: { country: "Maldives", nationality: "Maldivienne" },
  MW: { country: "Malawi", nationality: "Malawite" },
  MX: { country: "Mexique", nationality: "Mexicaine" },
  MY: { country: "Malaisie", nationality: "Malaisienne" },
  MZ: { country: "Mozambique", nationality: "Mozambicaine" },
  NA: { country: "Namibie", nationality: "Namibienne" },
  NE: { country: "Niger", nationality: "Nigérienne" },
  NG: { country: "Nigéria", nationality: "Nigériane" },
  NI: { country: "Nicaragua", nationality: "Nicaraguayenne" },
  NL: { country: "Pays-Bas", nationality: "Néerlandaise" },
  NO: { country: "Norvège", nationality: "Norvégienne" },
  NP: { country: "Népal", nationality: "Népalaise" },
  NR: { country: "Nauru", nationality: "Nauruane" },
  NZ: { country: "Nouvelle-Zélande", nationality: "Néo-zélandaise" },
  OM: { country: "Oman", nationality: "Omanaise" },
  PA: { country: "Panama", nationality: "Panaméenne" },
  PE: { country: "Pérou", nationality: "Péruvienne" },
  PG: { country: "Papouasie-Nouvelle-Guinée", nationality: "Papouane-Néo-Guinéenne" },
  PH: { country: "Philippines", nationality: "Philippine" },
  PK: { country: "Pakistan", nationality: "Pakistanaise" },
  PL: { country: "Pologne", nationality: "Polonaise" },
  PS: { country: "Territoire palestinien", nationality: "Palestinienne" },
  PT: { country: "Portugal", nationality: "Portugaise" },
  PW: { country: "Palaos", nationality: "Palaosienne" },
  PY: { country: "Paraguay", nationality: "Paraguayenne" },
  QA: { country: "Qatar", nationality: "Qatarienne" },
  RO: { country: "Roumanie", nationality: "Roumaine" },
  RS: { country: "Serbie", nationality: "Serbe" },
  RU: { country: "Russie", nationality: "Russe" },
  RW: { country: "Rwanda", nationality: "Rwandaise" },
  SA: { country: "Arabie saoudite", nationality: "Saoudienne" },
  SB: { country: "Îles Salomon", nationality: "Salomonaise" },
  SC: { country: "Seychelles", nationality: "Seychelloise" },
  SD: { country: "Soudan", nationality: "Soudanaise" },
  SE: { country: "Suède", nationality: "Suédoise" },
  SG: { country: "Singapour", nationality: "Singapourienne" },
  SI: { country: "Slovénie", nationality: "Slovène" },
  SK: { country: "Slovaquie", nationality: "Slovaque" },
  SL: { country: "Sierra Leone", nationality: "Sierra-Léonaise" },
  SM: { country: "Saint-Marin", nationality: "Saint-Marinaise" },
  SN: { country: "Sénégal", nationality: "Sénégalaise" },
  SO: { country: "Somalie", nationality: "Somalienne" },
  SR: { country: "Suriname", nationality: "Surinamaise" },
  SS: { country: "Soudan du Sud", nationality: "Soudanaise du Sud" },
  ST: { country: "Sao Tomé-et-Principe", nationality: "Santoméenne" },
  SV: { country: "Salvador", nationality: "Salvadorienne" },
  SY: { country: "Syrie", nationality: "Syrienne" },
  SZ: { country: "Eswatini", nationality: "Eswatinienne" },
  TD: { country: "Tchad", nationality: "Tchadienne" },
  TG: { country: "Togo", nationality: "Togolaise" },
  TH: { country: "Thaïlande", nationality: "Thaïlandaise" },
  TJ: { country: "Tadjikistan", nationality: "Tadjike" },
  TL: { country: "Timor-Leste", nationality: "Timoraise" },
  TM: { country: "Turkménistan", nationality: "Turkmène" },
  TO: { country: "Tonga", nationality: "Tonguienne" },
  TR: { country: "Turquie", nationality: "Turque" },
  TT: { country: "Trinité-et-Tobago", nationality: "Trinidadienne" },
  TV: { country: "Tuvalu", nationality: "Tuvaluane" },
  TW: { country: "Taïwan", nationality: "Taïwanaise" },
  TZ: { country: "Tanzanie", nationality: "Tanzanienne" },
  UA: { country: "Ukraine", nationality: "Ukrainienne" },
  UG: { country: "Ouganda", nationality: "Ougandaise" },
  US: { country: "États-Unis", nationality: "Américaine" },
  UY: { country: "Uruguay", nationality: "Uruguayenne" },
  UZ: { country: "Ouzbékistan", nationality: "Ouzbek" },
  VA: { country: "Vatican", nationality: "Vaticane" },
  VC: { country: "Saint-Vincent-et-les-Grenadines", nationality: "Saint-Vincentaise" },
  VE: { country: "Venezuela", nationality: "Vénézuélienne" },
  VN: { country: "Viêt Nam", nationality: "Vietnamienne" },
  VU: { country: "Vanuatu", nationality: "Vanuatuane" },
  WS: { country: "Samoa", nationality: "Samoane" },
  XK: { country: "Kosovo", nationality: "Kosovare" },
  YE: { country: "Yémen", nationality: "Yéménite" },
  ZA: { country: "Afrique du Sud", nationality: "Sud-Africaine" },
  ZM: { country: "Zambie", nationality: "Zambienne" },
  ZW: { country: "Zimbabwe", nationality: "Zimbabwéenne" },
} as const;

// Types
export type CountryCode = keyof typeof countryMap;

export type Country = (typeof countryMap)[CountryCode]["country"];
export type Nationality = (typeof countryMap)[CountryCode]["nationality"];

// Type guard: Check if string is a valid country code
export const isCountryCode = (code: string): code is CountryCode => code in countryMap;

// Helper: Get nationality for a country code
export const getNationality = (code: string | null | undefined): Nationality | null => {
  if (!code || !isCountryCode(code)) return null;
  return countryMap[code].nationality;
};

// Helper: Get country name
export const getCountryName = (code: string | null | undefined): Country | null => {
  if (!code || !isCountryCode(code)) return null;
  return countryMap[code].country;
};

// Helper: Validate if a string is a valid Nationality
export function isValidNationality(value: string | null | undefined): value is Nationality | null | undefined {
  if (value === null || value === undefined) return true;
  return Object.values(countryMap).some((entry) => entry.nationality === value);
}

// Helper: Safely convert string to Nationality
export function toNationality(value: string | null | undefined): Nationality | null | undefined {
  if (value === null || value === undefined) return value;
  return isValidNationality(value) ? value : null;
}

// All unique nationalities (for dropdowns)
export const getNationalities = (): [Nationality, ...Nationality[]] => {
  const unique = new Set<Nationality>();
  Object.values(countryMap).forEach(({ nationality }) => unique.add(nationality));
  const arr = Array.from(unique);
  return arr as [Nationality, ...Nationality[]];
};

// All countries
export const getCountries = (): [Country, ...Country[]] => {
  const arr = Object.values(countryMap).map(({ country }) => country);
  return arr as [Country, ...Country[]];
};

// Nationality options for select (value = code, label = nationality)
export const nationalityOptions = () => {
  return Object.entries(countryMap).map(([code, { nationality }]) => ({
    value: code,
    label: nationality,
  }));
};

// Country options for select (value = code, label = country name)
export const countryOptions = () => {
  return Object.entries(countryMap).map(([code, { country }]) => ({
    value: code,
    label: country,
  }));
};
